import React, {useState} from 'react';
import ReactPlayer from 'react-player';
import {isMobile} from '../../../utils/commonMethods';

const YoutubePlayerReact = ({hTTVideoKey, onStateChange, isHashtag}) => {
  const playerRef = React.useRef();
  const [playing, setPlaying] = useState(true);
  const defaultVideoUrl = hTTVideoKey
    ? hTTVideoKey
    : 'https://www.youtube.com/watch?v=luzJel0OxE8';

  const [videoUrl, setVideoUrl] = useState(defaultVideoUrl);

  return (
    <ReactPlayer
      ref={playerRef}
      url={videoUrl}
      playing={playing}
      width={isMobile() ? window.innerWidth - 32 : '100%'}
      height={isMobile() || isHashtag ? 240 : 400}
      onEnded={() => {
        playerRef.current.seekTo(0, 'seconds');
        setPlaying(false);
      }}
      controls={true}
      style={{borderRadius: 10, overflow: 'hidden', marginBottom: 20}}
    />
  );
};
export default YoutubePlayerReact;
